<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <tabela
          :item="item"
          :loading="loading"
          @rechargeTable="getAll()"
          @switchProcessamentosExpirados="
            processamentosExpirados = $event,
            getAll()
          "
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SimulacaoBaixasService from '@/services/SimulacaoBaixasService';
import pusherMixins from '@/mixins/pusherMixins';
import tourMixins from '@/mixins/tourMixins';

export default {

  components: {
    Tabela: () => import('@/components/simuladorBaixas/Tabela.vue')
  },
  mixins: [pusherMixins, tourMixins],

  data: () => ({
    item: [],
    loading: false,
    processamentosExpirados: false,
    arrTour:[
      {
        element: '#btn-nova-simulacao-baixas',
        intro: 'Clicando neste botão você poderá criar novas Simulações de Baixas.',
        scrollTo: 'tooltip',
        position: 'right'
      },
      {
        element: '#simulacao-baixas-historico-search',
        intro: 'Neste campo você poderá pesquisar por Simulações de Baixas já existentes.',
        scrollTo: 'tooltip',
        position: 'bottom'
      },
      {
        element: '#action-download-simulacao-baixas',
        intro: 'Clicando neste ícone você poderá fazer o download em .XLSX do resultado da sua Simulação de Baixas.',
        scrollTo: 'tooltip',
        position: 'left'
      },
      {
        element: '#action-edit-simulacao-baixas',
        intro: 'Clicando neste ícone você poderá editar sua Simulação de Baixas.',
        scrollTo: 'tooltip',
        position: 'left'
      },   
      {
        element: '#action-more-simulacao-baixas',
        intro: 'Aqui você acessa outras opções para sua Simulação de Baixas, como ver mais detalhes, executá-la novamente ou deletá-la.',
        scrollTo: 'tooltip',
        position: 'left'
      }
    ],
    loading: false
  }),

  mounted() {
    this.subscribe();
    this.getAll();
  },

  methods: {
    subscribe() {
      this.pusherChannel.bind('refresh-simulacoes-baixas', () => {
        this.getAll();
      });
    },

    getAll() {
      this.loading = true;

      SimulacaoBaixasService.getAllSimulacoes(this.processamentosExpirados)
        .then(response => this.item = response.data.simulacoesBaixas)
        .catch (error => {
          console.error(error);
          this.$toast.error('Erro ao recuperar simulações de baixas.', '', {position:'topRight'});
        }) 
        .finally(() => { this.loading = false, this.iniciarTourPagina();});
    },

    iniciarTourPagina() {
      if (this.tourFuncCalled) return;
  
      let arrTourFormatted = this.item.length ? this.arrTour : this.arrTour.splice(0, 2);
      this.iniciarTour(arrTourFormatted);
    }
  }
};
</script>